<template>
  <b-modal
      ref="cancel-kanban-be-modal"
      hide-footer
      title="Edition de votre carte Kanban BE"
  >
    <div class="d-block text-center">
      <b-container fluid>
        <br>
        <hr>
        <b-row>
          <b-col sm="2" style="margin:auto">
            <div v-show="loading" class="text-center">
              <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
            </div>
          </b-col>
          <b-col sm="5">
            <b-button
              class="mt-3"
              variant="outline-info"
              block
              @click="savedModification"
            >
              Annuler ce Kanban
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import server from '../../api/server.vue'

export default {
  name: 'CancelKanbanBeModal',
  data() {
    return {
      kanban: null,
      loading: false,
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    hideModal () {
      this.$refs['cancel-kanban-be-modal'].hide()
    },
    showModal (kanban) {
      console.log('here')
      this.kanban = kanban
      this.$refs['cancel-kanban-be-modal'].show()
      
    },
    savedModification () {
      this.loading = true
      server.cancelKanbanBe(this.kanban.card_number).then(res => {
        this.$toasted.success('Modification enregistrée !')
        this.$emit('saved')
        this.hideModal()
        this.cleanForm()
        this.loading = false
      }).catch((error) => {
        this.$toasted.error(`Mince ! Une erreur <br> ${error.response.data.message}`)
      })
    },
  },
  mounted: function() {
   
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// CancelKanbanBeModal.vue?32d862ae